<template>
    <v-card tile outlined elevation="0" class="pl-0 ml-0">

        <!--  <v-card-title class="py-2 white--text" style="background-color:#991f00;" >
            <v-spacer></v-spacer>
            <span class="body-1 text-center font-weight-bold">Factura: <span class="text-uppercase">{{this.order.n}}</span></span>
            <v-spacer></v-spacer>
        </v-card-title>
        -->

 
        <v-card-title class="py-2" style="background-color:#F5F5F5; color:#686D70; border-bottom: 1px solid #E0E0E0;">
            <v-icon>mdi-text-box-outline</v-icon>
            <span class="body-1 text-left ml-2 font-weight-bold">Factura: <span class="text-uppercase">{{this.order.n}}</span></span>
        </v-card-title>


        <!--  
        <v-list-item class="py-0 px-6" style="background-color:#F5F5F5; color:#686D70; border-bottom: 1px solid #E0E0E0;">
            <v-list-item-content>
                <v-list-item-title class="subtitle-1 mb-0 text-left font-weight-medium text--secondary">Entrega Kuroda</v-list-item-title>
                <v-list-item-subtitle class="body-2 text-left font-weight-bold">Factura: <span class="text-uppercase">{{this.order.n}}</span></v-list-item-subtitle>
            </v-list-item-content>
        </v-list-item>
        -->
       

        <v-card-text class="pl-0 pt-0 pb-0">
            <v-timeline dense dark>

                <!-- STATUS 0 (INGRESADO AL SISTEMA) -->
                <span>
                    <v-timeline-item small fill-dot 
                    :color='(this.order.s >= 0) ? "green darken-4": "red darken-4"' 
                    :icon='(this.order.s >= 0) ? "mdi-check-bold": "mdi-minus-thick"' 
                    v-show="this.order.s >= 0"
                    >
                        <strong>Pedido ingresado.</strong>
                        <div class="caption">agregado al sistema</div>
                        <div class="caption" >{{ this.order.tf ? formatDate(this.order.tf,1,false) : formatDate(this.order.st,1,false)}}</div>
                    </v-timeline-item>

                    <v-timeline-item small fill-dot 
                    color='red darken-4' 
                    icon='mdi-minus-thick' 
                    v-show="this.order.s == 0"
                    >
                        <strong>Asignación del pedido en curso.</strong>
                    </v-timeline-item>
                </span>
               
                <!-- STATUS 1(ASIGNADO A VEHICULO) -->
                <span>
                    <v-timeline-item small fill-dot 
                        color="green darken-4" 
                        icon="mdi-check-bold"
                        v-show="this.order.s >= 1"
                    >
                        <strong>Pedido asignado.</strong>
                        <div class="caption">Vehiculo asignado</div>
                        <div class="caption">{{formatDate(this.order.tf,1)}}</div>
                    </v-timeline-item> 
                </span>
                
                <!-- STATUS 2(PEDIDO COMPLETO) || STATUS 3(PEDIDO COMPLETO ATRASADO) -->
                <template v-if="this.order.p.r">
                    <v-timeline-item small fill-dot 
                    :color='(this.order.s == 1) ? "red darken-4": "green darken-4"' 
                    :icon='(this.order.s == 1) ? "mdi-minus-thick": "mdi-check-bold"' 
                    v-show="this.order.s == 1"
                >
                    <strong>Entrega del pedido en curso.</strong>
                    <div class="caption">Llegada estimada <br> {{formatDate(this.order.p.r.vt,1,true) }}</div>
                    </v-timeline-item>
                </template>

                <template v-if="this.order.ej">
                    <v-timeline-item small fill-dot 
                    :color='(this.order.s >= 2) ? "green darken-4": "red darken-4"' 
                    :icon='(this.order.s >= 2) ? "mdi-check-bold": "mdi-minus-thick"' 
                    v-show="this.order.s >= 2"
                >
                    <strong>Pedido entregado.</strong>
                    <div class="caption">Entregado a cliente <br> {{formatDate(this.order.st,1,true)}}</div>
                    </v-timeline-item>
                </template>

            

            </v-timeline>
        </v-card-text>


    </v-card>
</template>

<script>

  import Utils  from '../utils/utils'  

    export default {
        props: {
            order: {
                type    : Object,
                required: true
            },
        },
        methods: {
            formatDate (date,way,time) {
                let fecha = new Date( date * 1000) 
                let tiempo = fecha.toTimeString().substr(0,5)
                let newfecha = Utils.formatDate(fecha.toDateString(),way)
            
                if(time) {
                 return newfecha +" a las "+ tiempo
                } else {
                 return newfecha
                }
                
            },
        }
    }
</script>

<style>

</style>